import { render, staticRenderFns } from "./LawAuthoritySubCategoryForm.vue?vue&type=template&id=56dd7008&"
import script from "./LawAuthoritySubCategoryForm.vue?vue&type=script&lang=js&"
export * from "./LawAuthoritySubCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./LawAuthoritySubCategoryForm.vue?vue&type=style&index=0&id=56dd7008&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports